<ngx-slider [(value)]="min" [(highValue)]="max" [options]="options" (valueChange)="updateMin($event)" (highValueChange)="updateMax($event)" class="a3l-ui-range-input-slider"></ngx-slider>
<div class="a3l-ui-range-input-controls">
  <input type="number" a3l-ui-input [(ngModel)]="min" (input)="updateMin($event.target.value)" (change)="clampMin()" class="a3l-ui-range-input-controls__item" />
  <span class="a3l-ui-range-input-controls__delimiter">-</span>
  <input type="number" a3l-ui-input [(ngModel)]="max" (input)="updateMax($event.target.value)" (change)="clampMax()" class="a3l-ui-range-input-controls__item" />
</div>
